<template>
  <div v-if="hasAnyPermission('sap-configuration-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <!-- Bagian H% di Kiri -->
          <div class="col-4">
            <h5 class="mb-0">SAP Configuration</h5>
          </div>

          <!-- Bagian Pencarian di Tengah -->
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon class="pi pi-search" />
              <InputText
v-model="table.search" type="text" size="small" placeholder="Search SAP Configuration"
                class="rounded-pill w-100" @keyup="filter" />
            </IconField>
          </div>

          <!-- Bagian Button di Kanan -->
          <div v-if="hasAnyPermission('sap-configuration-create')" class="col-4 text-end">
            <button type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
          </div>
        </div>
      </div>
      <div style="height: 500px; overflow-y: auto">
        <DataTable :value="table.data" removable-sort scrollable scroll-height="flex" table-style="min-width: 100rem">
          <Column header="SAP Sync" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.code }}</span>
            </template>
          </Column>
          <Column header="SAP Sync Name" header-class="bg-light" sortable>
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.sync_name }}</span>
            </template>
          </Column>
          <Column header="Connection" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.connection }}</span>
            </template>
          </Column>
          <Column header="Function Type" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.function_type }}</span>
            </template>
          </Column>
          <Column header="Function" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.function }}</span>
            </template>
          </Column>
          <Column header="Last Sync by" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.last_sync_by }}</span>
            </template>
          </Column>
          <Column header="Last Sync at" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.last_sync_at }}</span>
            </template>
          </Column>
          <Column header="Status" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else :class="row.data.status === 'active' ? 'badge badge-success' : 'badge badge-danger'">{{
                row.data.status === 'active' ? "Active" : "Inactive" }}</span>
            </template>
          </Column>
          <Column field="actions" header="Actions" header-class="bg-light text-dark" sortable>
            <template v-if="table.onLoad" #body>
              <Skeleton></Skeleton>
            </template>
            <template v-else #body="row">
              <div v-if="table.data.length > 0 && !table.onLoad">
                <ButtonPrime v-if="hasAnyPermission('sap-configuration-update')"
v-tooltip.bottom="'Edit'" icon="pi pi-pencil" outlined rounded
                  size="small" @click="openEditModal(row.data)" />
                <ButtonPrime v-if="hasAnyPermission('sap-configuration-delete')"
v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                  size="small" style="margin-left: 5px;" @click="deleteItem(row.data.id)" />
                <ButtonPrime
v-tooltip.bottom="'To Params'" icon="pi pi-chevron-circle-right" outlined rounded
                  severity="help" size="small" style="margin-left: 5px;" @click="toParam(row.data.code)" />
              </div>
              <div v-else class="m-4"><span /></div>
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 35px 0;">
              <img src="/no_data.png" alt="No Data" style="width: 330px; height: 330px; opacity: 0.7;" />
              <p class="text-muted mt-2">No items found</p>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
v-model="table.page.current_page" :page-count="table.page.total_page" size="sm"
          @click="changePage()" />
        <p>
          {{ (table.page.current_page - 1) * table.page.per_page + table.data.length }}
          of {{ table.total }}
        </p>
      </div>
    </div>

    <DialogPrime v-model:visible="modal.visible" :header="modal.title" style="width: 45rem; margin: 10px;">
      <div class="mb-2 row">
        <div class="col-md-6 col-sm-12">
          <label for="client" class="font-semibold">Client <span class="text-danger">*</span></label>
          <SelectPrime
id="client" v-model="modal.data.client" :options="optClient" option-label="description"
            option-value="code" placeholder="Please choose client"
            :invalid="modal.errorMessage['client'] && modal.data.client === ''" class="w-full md:w-56" fluid />
          <small v-if="modal.errorMessage['client'] && modal.data.client == ''" class="text-danger">{{
            modal.errorMessage['client'] }}</small>
        </div>

        <div class="col-md-6 col-sm-12">
          <label for="code" class="font-semibold">Code <span class="text-danger">*</span></label>
          <InputText
id="code" v-model="modal.data.code" placeholder="Eg: ZA01_GET_EQUI_LIST"
            :class="`${(modal.errorMessage['code'] && modal.data.code == '') ? 'border-danger' : ''}`"
            fluid @input="toUpperCaseVal($event, 'code')" />
          <small v-if="modal.errorMessage['code'] && modal.data.code == ''" class="text-danger">{{
            modal.errorMessage['code'] }}</small>
        </div>
      </div>

      <div class="mb-2 row">
        <div class="col-md-6 col-sm-12">
          <label for="sync_name" class="font-semibold">Sync Name <span class="text-danger">*</span></label>
          <InputText
id="sync_name" v-model="modal.data.sync_name" placeholder="Eg: Get Equipment List"
            :class="`${(modal.errorMessage['sync_name'] && modal.data.sync_name == '') ? 'border-danger' : ''}`"
            fluid />
          <small v-if="modal.errorMessage['sync_name'] && modal.data.sync_name == ''" class="text-danger">{{
            modal.errorMessage['sync_name'] }}</small>
        </div>
        <div class="col-md-6 col-sm-12">
          <label for="function" class="font-semibold">Function <span class="text-danger">*</span></label>
          <InputText
id="function" v-model="modal.data.function" placeholder="Eg: App\Libraries\Script\CharChange"
            :class="`${(modal.errorMessage['function'] && modal.data.function == '') ? 'border-danger' : ''}`" fluid />
          <small v-if="modal.errorMessage['function'] && modal.data.function == ''" class="text-danger">{{
            modal.errorMessage['function'] }}</small>
        </div>
      </div>

      <div class="mb-2 row">
        <div class="col-md-6 col-sm-12">
          <label for="function_type" class="font-semibold">Function Type <span class="text-danger">*</span></label>
          <SelectPrime
id="function_type" v-model="modal.data.function_type" :options="optFunctionType"
            option-label="label" option-value="code" placeholder="Please choose function type"
            :invalid="modal.errorMessage['function_type'] && modal.data.function_type === ''" class="w-full md:w-56"
            fluid />
          <small v-if="modal.errorMessage['function_type'] && modal.data.function_type == ''" class="text-danger">{{
            modal.errorMessage['function_type'] }}</small>
        </div>
        <div class="col-md-6 col-sm-12">
          <label for="integration_type" class="font-semibold">Integration Type <span
              class="text-danger">*</span></label>
          <SelectPrime
id="integration_type" v-model="modal.data.integration_type" :options="optIntegration"
            option-label="label" option-value="code" placeholder="Please choose integration type"
            :invalid="modal.errorMessage['integration_type'] && modal.data.integration_type === ''"
            class="w-full md:w-56" fluid />
          <small
v-if="modal.errorMessage['integration_type'] && modal.data.integration_type == ''"
            class="text-danger">{{
              modal.errorMessage['integration_type'] }}</small>
        </div>
      </div>

      <div class="mb-5 row">
        <div class="col-md-6 col-sm-12">
          <label for="status" class="font-semibold">Status <span class="text-danger">*</span></label>
          <SelectPrime
id="status" v-model="modal.data.status" :options="optStatus" option-label="label"
            option-value="code" placeholder="Please choose status"
            :invalid="modal.errorMessage['status'] && modal.data.status === ''" class="w-full md:w-56" fluid />
          <small v-if="modal.errorMessage['status'] && modal.data.status == ''" class="text-danger">{{
            modal.errorMessage['status'] }}</small>
        </div>
      </div>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime
type="button" label="Cancel" severity="danger" class="px-4 border-0" raised size="small"
            :disabled="modal.onLoading" @click="modal.visible = false" />
          <ButtonPrime v-if="canSaveModal"
type="button" severity="contrast" raised size="small" label="Save" class="px-4" :disabled="modal.onLoading"
            @click="save()">
            <template v-if="modal.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import api from "@/helpers/api";
import sapSyncService from "@/services/sap/sapSyncService"
import clientService from "@/services/generalMasterData/clientService"

export default {
  components: {
    NoAccess,
  },
  data() {
    return {
      table: {
        search: this.$route.query.search ? this.$route.query.search : "",
        onLoad: false,
        total: 3,
        data: [{}],
        page: {
          current_page: 1,
          total_page: 1,
        },
        limit: 100,
        loadTimeout: null,
      },
      modal: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
      optClient: [],
      optIntegration: [{ label: 'Manual', code: 'manual' }, { label: 'Cronjob', code: 'cronjob' }],
      optStatus: [{ label: 'Active', code: 'active' }, { label: 'Inactive', code: 'inactive' }],
      optFunctionType: [{ label: 'Script', code: 'script' }, { label: 'Pipo', code: 'pipo' }]
    };
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    anyEmptyVal() {
      // return (!this.modal.data.characteristic || !this.modal.data.char_sap || !this.modal.data.single_or_multiple || !this.modal.data.label || !this.modal.data.position || !this.modal.data.space );
      return true
    },
    canSaveModal() {
      if (this.modal.action === 'edit') return this.hasAnyPermission('sap-configuration-update');
      return this.hasAnyPermission('sap-configuration-create');
    }
  },
  mounted() {
    if (this.hasAnyPermission('sap-configuration-view')) {
      this.get()
      this.getClient()
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async get() {
      this.table.onLoad = true
      try {
        const response = await api(this, sapSyncService.list({ limit: this.table.limit, page: this.table.page.current_page, search: this.table.search }), false);

        this.table.data = response.data.data;
        this.table.total = response.data.total;
        this.table.page.current_page = response.data.current_page;
        this.table.page.total_page = response.data.last_page;
      } catch (error) {
        this.table.data = [{}]
        this.table.total = 0
      } finally {
        this.table.onLoad = false
      }
    },
    async getClient() {
      try {
        const response = await api(this, clientService.list(), false);

        this.optClient = response.data;
      } catch (error) {
        this.optClient = []
      }
    },
    openAddModal() {
      this.modal = {
        visible: true,
        action: "create",
        title: "Add SAP Sync",
        data: { id: "", client: "", code: "", sync_name: "", function_type: "", function: "", integration_type: "", status: "" },
        errorMessage: {},
        onLoading: false,
      }
    },
    openEditModal(item) {
      this.modal = {
        visible: true,
        action: "edit",
        title: "Edit SAP Sync",
        data: { id: item.id, client: item.client, code: item.code, sync_name: item.sync_name, function_type: item.function_type, function: item.function, integration_type: item.integration_type, status: item.status },
        originalData: { id: item.id, client: item.client, code: item.code, sync_name: item.sync_name, function_type: item.function_type, function: item.function, integration_type: item.integration_type, status: item.status },
        errorMessage: {},
        onLoading: false,
      };
    },
    deleteItem(id) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          this.table.onLoad = true
          api(this, sapSyncService.delete(id)).then(() => { this.get() }).catch(() => {
            this.table.onLoad = false
          });
        }
      });
    },
    toParam(code) {      
      this.$router.push({ name: "SAP Sync Params", params: { moduleSlug: 'material-management', sapSync: code } });
    },
    save() {
      let isValid = true;
      const allFields = [{ key: "client", message: "Client" }, { key: "code", message: "Code" }, { key: "sync_name", message: "Sync Name" }, { key: "function", message: "Function" }, { key: "function_type", message: "Function Type" }, { key: "integration_type", message: "Integration Type" }, { key: "status", message: "Status" }];
      
      // Clear previous errors
      allFields.forEach((val) => {
        this.modal.errorMessage[val.key] = null;
      });

      // For CREATE: all fields required
      // For EDIT: partial update - only validate fields that were changed
      if (this.modal.action === 'create') {
        allFields.forEach((val) => {
          if (!this.modal.data[val.key]) {
            this.modal.errorMessage[val.key] = `${val.message} is required`;
            isValid = false;
          }
        });
      } else if (this.modal.action === 'edit') {
        // For partial update, only validate changed fields
        allFields.forEach((val) => {
          const originalValue = this.modal.originalData[val.key];
          const currentValue = this.modal.data[val.key];
          
          // If field was changed, validate it
          if (currentValue !== originalValue) {
            if (!currentValue) {
              this.modal.errorMessage[val.key] = `${val.message} is required`;
              isValid = false;
            }
          }
        });
      }

      if (!isValid) {
        this.$toastNotifPrime('error', 'Validation Failed', 'There field is empty')
        return false;
      };

      // Prepare payload
      let payload;
      if (this.modal.action === 'edit') {
        // For EDIT: only send changed fields (partial update)
        payload = {};
        allFields.forEach((val) => {
          const originalValue = this.modal.originalData[val.key];
          const currentValue = this.modal.data[val.key];
          
          if (currentValue !== originalValue) {
            payload[val.key] = currentValue;
          }
        });

        // If no fields were changed, show message and return
        if (Object.keys(payload).length === 0) {
          this.$toastNotifPrime('info', 'Info', 'No changes detected')
          this.modal.onLoading = false;
          return;
        }
      } else {
        // For CREATE: send all fields
        payload = {
          client: this.modal.data.client,
          code: this.modal.data.code,
          sync_name: this.modal.data.sync_name,
          function_type: this.modal.data.function_type,
          function: this.modal.data.function,
          integration_type: this.modal.data.integration_type,
          status: this.modal.data.status
        };
      }

      this.modal.onLoading = true
      setTimeout(async () => {
        try {
          if (this.modal.action === 'create') {
            await api(this, sapSyncService.create(payload));
          } else if (this.modal.action === 'edit') {
            await api(this, sapSyncService.update(this.modal.data.id, payload))
          }
          this.modal.data = {};
          this.modal.visible = false;
          this.get();
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modal.onLoading = false
        }
      }, 500)
    },
    filter() {
      if (this.table.search != this.$route.query.search) {
        clearTimeout(this.table.loadTimeout);
        this.table.loadTimeout = setTimeout(() => {
          if (this.table.search.length > 3) {
            this.table.search = this.table.search.toUpperCase()
            this.$router.push({ query: { search: this.table.search } });
          } else {
            this.$router.push({ query: null, });
          }

          this.get();
        }, 500)
      }
    },
    changePage() {
      this.table.onLoad = true;
      setTimeout(() => {
        this.get();
      }, 100);
    },
    toUpperCaseVal(event, key) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      const upper = input.value.toUpperCase();
      this.modal.data[key] = upper;

      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
                // errorData[key].forEach(message => {
                //   this.$toastNotifPrime('error', error.response.data.message, message);
                // });
              }
            }
          }
        }
      }
    },
  },
};
</script>
